import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ContainerLeftSide = styled.div`
  display: flex;
  flex: 1;
`;

export const ContainerRightSide = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  justify-content: flex-start;
  flex: 1;
`;

export const ContainerResults = styled.div`
  gap: 20px;
  display: flex;
  justify-content: flex-start;
`;

export const ContainerRecommendation = styled.div``;

export const RecommendationBox = styled.div`
  background-color: #FFC0C0;
  border-radius: 4px;
  padding: 10px;
  width: fit-content;
  margin-bottom: 20px;
`;
